import { KYMW5400Component } from './kymw5400.component';
import { GetCWSPlanGoodsSearchModel } from './vo/get-cws-plan-goods-search.model';
import { KYMW5400commonModel } from './vo/kymw5400-common.model';
import { KYMW0300InputModel } from '../../../commons/kymw03/kymw0300/vo/kymw0300-input.model';

/**
 * ECカテゴリ関連マスタ画面の値を管理するクラス
 *
 * @export KYMW5400Model
 * @class KYMW5400Model
 */
export class KYMW5400Model {

  public kymw5400Component: KYMW5400Component;

  // 生協フラグ項目名
  private readonly COOP_COL_ID1: string = String('CoopFlgI');
  private readonly COOP_COL_ID2: string = String('CoopFlgTo');
  private readonly COOP_COL_ID3: string = String('CoopFlgGu');
  private readonly COOP_COL_ID4: string = String('CoopFlgChi');
  private readonly COOP_COL_ID5: string = String('CoopFlgSa');
  private readonly COOP_COL_ID6: string = String('CoopFlgTou');
  private readonly COOP_COL_ID7: string = String('CoopFlgNa');
  private readonly COOP_COL_ID8: string = String('CoopFlgNi');

  // カテゴリ一覧データ
  public categoryInfoList: Array<any> = [];

  // カテゴリ商品設定一覧データ
  public categoryGoodsList: Array<any> = [];

  // CWS商品企画一覧の開始件数
  public startDispNum = Number(0);

  // CWS商品企画一覧の終了件数
  public endDispNum = Number(0);

  // CWS商品企画一覧の総件数
  public totalNum = Number(0);

  public prevDisabled = true;
  public nextDisabled = true;

  // CWS商品一覧データ
  public goodsList: Array<any> = [];

  // EC掲載順
  public ecShowSeq = Number(0);

  // カテゴリ商品設定一覧の生協・いばらき 商品件数
  public coopIGoodsCount = Number(0);

  // カテゴリ商品設定一覧の生協・とちぎ 商品件数

  public coopToGoodsCount = Number(0);

  // カテゴリ商品設定一覧の生協・ぐんま 商品件数
  public coopGuGoodsCount = Number(0);

  // カテゴリ商品設定一覧の生協・ちば 商品件数
  public coopChiGoodsCount = Number(0);

  // カテゴリ商品設定一覧の生協・さいたま 商品件数
  public coopSaGoodsCount = Number(0);

  // カテゴリ商品設定一覧の生協・とうきょう 商品件数
  public coopTouGoodsCount = Number(0);

  // カテゴリ商品設定一覧の生協・ながの 商品件数
  public coopNaGoodsCount = Number(0);

  // カテゴリ商品設定一覧の生協・にいがた 商品件数
  public coopNiGoodsCount = Number(0);

  // カテゴリ商品設定一覧の全生協 商品件数
  public coopAllGoodsCount = Number(0);

  // CWS商品企画一覧の現在ページ
  public pageNum = Number(1);

  // ソートキー
  public sortKey = String('');

  // ソート順
  public sortOrder = String('');

  // 編集有無フラグ
  public isEdited = Boolean(false);

  // 受注コード
  public orderCode = String('');

  // ツリー検索時の受注コード
  public treeOrderCode = String('');

  // 在庫限定フラグ
  public stockLimitFlg = String('');

  // 画面紐づけ
  // ラジオボタン選択値
  public categoryDiv = String('1');

  // 配達企画回
  public catalogID = String('');

  // サーバーデータ仮入れ
  private dbItems: any = null;

  /**
   * カテゴリマスタ取得結果
   * @param serverData ユーザーリストのサーバ取得データ
   */
  public getCategory(serverData: any): void {

    this.treeOrderCode = this.orderCode;

    // 検索結果のチェック
    if (serverData.Category === null) {										// 該当データなしの場合
      // カテゴリ一覧クリア
      this.clean();

      // カテゴリ商品設定一覧をクリア
      this.categoryGoodsList = [];
      // 商品件数をクリア
      this.initGoodsCount();

      // フォーカス設定
      this.kymw5400Component.btn_Display.nativeElement.focus();
      // 処理復帰
      return;
    }
    
    // DB取得値からプロパティを選んで自身にコピーする
    this.dbItems = serverData.Category;
    this.categoryInfoList = [];

    // カテゴリ一覧初期化処理  第１階層カテゴリデータの初期化処理
    for (let i = Number(0); i < this.dbItems.length; i++) {

      this.categoryInfoList.push(this.dbItems[i]);
      this.categoryInfoList[i].CategoryName = this.dbItems[i].CategoryCode + ':' + this.dbItems[i].CategoryName;
      this.categoryInfoList[i].SellAreaDivB = this.dbItems[i].SellAreaDivB.slice(7, 8);
      this.categoryInfoList[i].SellAreaDivN = this.dbItems[i].SellAreaDivN.slice(6, 7);
      this.categoryInfoList[i].SellAreaDivM = this.dbItems[i].SellAreaDivW.slice(5, 6);
      this.categoryInfoList[i].SellAreaDivW = this.dbItems[i].SellAreaDivM.slice(4, 5);

      // 子カテゴリがあった場合 第２階層カテゴリデータの初期化処理
      if ('Category' in this.dbItems[i]) {
        const list2 = []; // 子カテゴリを仮に入れる配列を定義する
        for (let j = Number(0); j < this.dbItems[i].Category.length; j++) {
          // ソートにより、子カテゴリを取得し、仮置き配列に追加する
          list2.push(this.dbItems[i].Category[j]);
          list2[j].CategoryName = this.dbItems[i].Category[j].CategoryCode + ':' + this.dbItems[i].Category[j].CategoryName;
          list2[j].SellAreaDivB = this.dbItems[i].Category[j].SellAreaDivB.slice(7, 8);
          list2[j].SellAreaDivN = this.dbItems[i].Category[j].SellAreaDivN.slice(6, 7);
          list2[j].SellAreaDivM = this.dbItems[i].Category[j].SellAreaDivM.slice(5, 6);
          list2[j].SellAreaDivW = this.dbItems[i].Category[j].SellAreaDivW.slice(4, 5);

          // 孫カテゴリがあった場合 第３階層カテゴリデータの初期化処理
          if ('Category' in this.dbItems[i].Category[j]) {
            const list3 = []; // 孫カテゴリを仮に入れる配列を定義する
            for (let k = Number(0); k < this.dbItems[i].Category[j].Category.length; k++) {
              // ソートにより、孫カテゴリを取得し、仮置き配列に追加する
              list3.push(this.dbItems[i].Category[j].Category[k]);
              list3[k].CategoryName = this.dbItems[i].Category[j].Category[k].CategoryCode + ':' + this.dbItems[i].Category[j].Category[k].CategoryName;
              list3[k].SellAreaDivB = this.dbItems[i].Category[j].Category[k].SellAreaDivB.slice(7, 8);
              list3[k].SellAreaDivN = this.dbItems[i].Category[j].Category[k].SellAreaDivN.slice(6, 7);
              list3[k].SellAreaDivM = this.dbItems[i].Category[j].Category[k].SellAreaDivM.slice(5, 6);
              list3[k].SellAreaDivW = this.dbItems[i].Category[j].Category[k].SellAreaDivW.slice(4, 5);

            }
            // 第２階層カテゴリへ第３階層配列を追加
            list2[j].Category = [];
            list2[j].Category = list3;
          }
        }
        // 第１階層カテゴリへ第２階層配列を追加
        this.categoryInfoList[i].Category = [];
        this.categoryInfoList[i].Category = list2;
      }
    }

    // ツリーの再描画を行う
    this.kymw5400Component.updateTreeView();

    // カテゴリ商品設定一覧をクリア
    this.kymw5400Component.categoryGoodsListClear();

    // 商品件数をクリア
    this.initGoodsCount();

    // 商品検索ボタンを活性にする
    this.kymw5400Component.plessEnabled(this.kymw5400Component.btn_Search, true);

    // カテゴリ一覧を活性にする
    this.kymw5400Component.tre_Category.isDisabled = false;

    // フォーカス設定
    this.kymw5400Component.btn_Display.nativeElement.focus();
  }

  /**
   * カテゴリ関連マスタ取得結果
   * @param serverData ユーザーリストのサーバ取得データ
   */
  public getGoodsCategory(serverData: any): void {

    // 商品件数を初期化
    this.initGoodsCount();
    // 検索結果のチェック
    if (serverData != null) {	// 該当データありの場合

      // カテゴリ商品設定一覧データの初期化
      this.categoryGoodsList = serverData.Category.List;

      // 全生協 商品件数にカテゴリ商品設定一覧データの件数を設定
      this.coopAllGoodsCount = this.categoryGoodsList.length;

      // カテゴリ商品設定一覧より商品件数をカウントする
      for (let i = Number(0); i < this.categoryGoodsList.length; i++) {
        // 編集チェック用のフラグ設定
        this.categoryGoodsList[i].isAlreadyExist = true;
        this.categoryGoodsList[i].isEditedECShowSeq = false;

        // いばらき
        if (this.categoryGoodsList[i][this.COOP_COL_ID1] === '2') { // 2:設定済の場合
          this.coopIGoodsCount++;
        }
        // とちぎ
        if (this.categoryGoodsList[i][this.COOP_COL_ID2] === '2') { // 2:設定済の場合
          this.coopToGoodsCount++;
        }
        // ぐんま
        if (this.categoryGoodsList[i][this.COOP_COL_ID3] === '2') { // 2:設定済の場合
          this.coopGuGoodsCount++;
        }
        // ちば
        if (this.categoryGoodsList[i][this.COOP_COL_ID4] === '2') { // 2:設定済の場合
          this.coopChiGoodsCount++;
        }
        // さいたま
        if (this.categoryGoodsList[i][this.COOP_COL_ID5] === '2') { // 2:設定済の場合
          this.coopSaGoodsCount++;
        }
        // とうきょう
        if (this.categoryGoodsList[i][this.COOP_COL_ID6] === '2') { // 2:設定済の場合
          this.coopTouGoodsCount++;
        }
        // ながの
        if (this.categoryGoodsList[i][this.COOP_COL_ID7] === '2') { // 2:設定済の場合
          this.coopNaGoodsCount++;
        }
        // にいがた
        if (this.categoryGoodsList[i][this.COOP_COL_ID8] === '2') { // 2:設定済の場合
          this.coopNiGoodsCount++;
        }
      }
    } else {															// 該当データなしの場合
      // カテゴリ商品設定一覧をクリア
      this.kymw5400Component.categoryGoodsListClear();
    }
    // フォーカス設定
    this.kymw5400Component.tre_Category.focus();
  }

  /**
   * 商品検索結果の画面反映
   */
  public setSearchResult(serverData: any): void {
    // ページング関連項目初期化
    this.goodsList = serverData.GoodsList;
    this.totalNum = Number(serverData.TotalNum);
    this.startDispNum = Number(serverData.StartDispNum);
    this.endDispNum = Number(serverData.EndDispNum);

    // 全件数と当該ページ最終行番号の比較
    // 全件数が当該ページ最終行番号より大きい場合、次へボタンを有効化
    if (this.totalNum > this.endDispNum) { // 次ページデータありの場合
      // 活性制御
      this.nextDisabled = false; // 次へボタン
    } else {  // 次ページデータなしの場合
      // 活性制御
      this.nextDisabled = true; // 次へボタン
    }

    // 当該ページ先頭行番号のチェック
    // 当該ページ先頭行番号が１より大きい場合、前へボタンの有効化制御
    if (this.startDispNum > 1) { // 前ページデータありの場合
      // 活性制御
      this.prevDisabled = false; // 前へボタン
    } else { // 前ページデータなしの場合
      // 活性制御
      this.prevDisabled = true; // 前へボタン
    }

    // 商品一覧の有効化
    this.kymw5400Component.dtg_GoodsList.isDisabled = false;						// 商品一覧

    // 商品一覧のリフレッシュ
    // this.goodsList.refresh();    

    // 行選択へ切り替える選択できないようにする。「0:選択不可」「3:行選択」
    // this.kymw5400Component.dtg_GoodsList.selectionMode = 3;
  }

  /**
   * 商品検索用ＶＯ取得
   */
  public getGetCWSPlanGoodsSearchVO(inputVo: KYMW0300InputModel): GetCWSPlanGoodsSearchModel {
    const vo: GetCWSPlanGoodsSearchModel = new GetCWSPlanGoodsSearchModel();

    vo.categoryDiv = String(this.categoryDiv);
    vo.orderCode = this.orderCode;
    vo.pcode = inputVo.pcode;
    vo.itemCode = inputVo.itemCode;
    vo.janCode = inputVo.janCode;
    vo.makerName = inputVo.makerName;
    vo.ordrClientCode = inputVo.ordrClientCode;
    vo.ordrClientKanji = inputVo.ordrClientKanji;
    vo.payeeClientCode = inputVo.payeeClientCode;
    vo.payeeClientKanji = inputVo.payeeClientKanji;
    vo.classCode = inputVo.classCode;
    vo.middleClassCode = inputVo.middleClassCode;
    vo.smallClassCode = inputVo.smallClassCode;
    vo.registDateFrom = inputVo.registDateFrom;
    vo.registDateTo = inputVo.registDateTo;
    vo.updateDateFrom = inputVo.updateDateFrom;
    vo.updateDateTo = inputVo.updateDateTo;
    vo.admitStatus = inputVo.admitStatus;
    vo.buyerCode = inputVo.buyerCode;
    vo.guideGoodsNameList = inputVo.guideGoodsNameList;
    vo.guideStandardNameList = inputVo.guideStandardNameList;
    vo.coopCodeList = inputVo.coopCodeList;
    vo.pcodeList = inputVo.pcodeList;
    vo.pageNo = this.pageNum;
    vo.sortKey = this.sortKey;
    vo.sortOrder = this.sortOrder;
    vo.stockLimitFlg = this.stockLimitFlg;
    vo.tagIdList = inputVo.tagId;
    vo.tagSearchType = inputVo.tagSearchType;
    vo.goodsMarkList = inputVo.goodsMark;
    vo.goodsMarkSearchType = inputVo.goodsMarkSearchType;
    vo.itemCodeList = inputVo.itemCodeList;
    vo.dutiesList = inputVo.duties;
    vo.dataKbnFlg = inputVo.dataKbnFlg;
    vo.goodsDiv = inputVo.goodsDiv;
    vo.searchMediumType = inputVo.mediumType;
    vo.searchOrderCode = inputVo.orderCode;
    vo.specialFeature = inputVo.specialFeature;
    vo.catalogCodeList = inputVo.catalogCode;
    vo.catalogCodeSearchType = inputVo.catalogCodeSearchType;
    vo.pageNoList = inputVo.pageNo;
    // 商品検索用VOを返却
    return vo;
  }

  /**
   * カテゴリ商品設定一覧追加処理
   */
  public addCategoryGoodsItem(goods: any): boolean {
    // 存在チェック
    for (let i = Number(0); i < this.categoryGoodsList.length; i++) { // カテゴリ設定商品一覧データ数分ループ
      // 商品一覧で選択された商品のＰコードとカテゴリ設定商品一覧に表示中商品のＰコードの比較
      if (goods.Pcode === this.categoryGoodsList[i].PCode) { // 同一コードの場合
        // 追加結果を返却
        // 存在する場合は追加しない
        return false;
      }
    }

    // カテゴリ設定商品一覧追加処理
    const obj: any = new Object();
    obj.isAlreadyExist = false;
    obj.isEditedECShowSeq = false;
    obj.ClassCode = goods.ClassCode;									// 部門コード
    obj.ClassName = goods.ClassNameKanji;								// 部門名称（漢字）
    obj.ClassCodeName = goods.ClassCodeName;								// 部門コード・名称
    obj.SmallClassCode = goods.SmallClassCode;								// 小分類コード
    obj.SmallClassName = goods.SmallClassName;								// 小分類名称（漢字）
    obj.SmallClassCodeName = goods.SmallClassCodeName;							// 小分類コード・名称
    obj.PCode = goods.Pcode;										// Ｐコード
    obj.GuideGoodsName = goods.GoodsName;									// 商品名
    obj.GuideStandardName = goods.GoodsStandardName;							// 規格名

    // ※カテゴリ区分が「0：商品マスタ」、「1：商品企画マスタ」、「2：在庫限定カテゴリ」の場合、全生協に対して「設定」とする。
    let val = '1';
    // カテゴリ区分から 「0：商品マスタ」 を外したため、条件を修正
    // if (this.categoryDiv === '0' || this.categoryDiv === '1' || this.categoryDiv === '2') {
     if (this.categoryDiv === '1' || this.categoryDiv === '2') {
      val = '3';
    }

    // 取扱可能生協の場合valを入れる
    obj.CoopFlgI = (goods.CoopFlgI === '1') ? val: '0';
    obj.CoopFlgTo = (goods.CoopFlgTo === '1') ? val: '0';
    obj.CoopFlgGu = (goods.CoopFlgGu === '1') ? val: '0';
    obj.CoopFlgChi = (goods.CoopFlgChi === '1') ? val: '0';
    obj.CoopFlgSa = (goods.CoopFlgSa === '1') ? val: '0';
    obj.CoopFlgTou = (goods.CoopFlgTou === '1') ? val: '0';
    obj.CoopFlgNa = (goods.CoopFlgNa === '1') ? val: '0';
    obj.CoopFlgNi = (goods.CoopFlgNi === '1') ? val: '0';

    this.categoryGoodsList.push(obj);

    // 初期化処理
    this.isEdited = true;												// 編集フラグ(編集中)

    // 活性制御
    this.kymw5400Component.plessEnabled(this.kymw5400Component.txti_OrderCode, false);					// 受注コード
    this.kymw5400Component.plessEnabled(this.kymw5400Component.btn_Display, false);					// 表示ボタン
    this.kymw5400Component.tre_Category.isDisabled = true; // カテゴリ一覧
    this.kymw5400Component.plessEnabled(this.kymw5400Component.btn_Cancel, true);					// 取消ボタン
    this.kymw5400Component.plessEnabled(this.kymw5400Component.btn_Update, true);					// 更新ボタン

    // グリッドの更新
    this.kymw5400Component.dtg_CategoryGoodsList.editableCollectionView.refresh();

    // 追加結果を返却
    return true;
  }

  /**
   * カテゴリ関連一覧「設定」処理
   */
  public setCoopFlg(pcode: string, colId: string): void {
    // 対象行を取得
    const row: number = this.getCategoryGoodsRowNum(pcode);

    // 対象行のチェック
    if (row < 0) { // 未選択の場合
      return;
    }

    // フラグを設定
    this.categoryGoodsList[row][colId] = this.getSetCoopFlg(this.categoryGoodsList[row][colId]);
  }

  /**
   * カテゴリ関連一覧「解除」処理
   */
  public unsetCoopFlg(pcode: string, colId: string): void {
    // 対象行を取得
    const row: number = this.getCategoryGoodsRowNum(pcode);

    // 対象行のチェック
    if (row < 0) { // 未選択の場合
      return;
    }

    // フラグを設定
    this.categoryGoodsList[row][colId] = this.getUnsetCoopFlg(this.categoryGoodsList[row][colId]);
  }

  /**
   * カテゴリ関連一覧「全生協に設定」処理
   */
  public setCoopFlgAll(pcode: string, colId: string): void {
    // 対象行を取得
    const row: number = this.getCategoryGoodsRowNum(pcode);

    // 対象行のチェック
    if (row < 0) { // 未選択の場合
      return;
    }

    // フラグを設定
    this.categoryGoodsList[row][this.COOP_COL_ID1] = this.getSetCoopFlg(this.categoryGoodsList[row][this.COOP_COL_ID1]);
    this.categoryGoodsList[row][this.COOP_COL_ID2] = this.getSetCoopFlg(this.categoryGoodsList[row][this.COOP_COL_ID2]);
    this.categoryGoodsList[row][this.COOP_COL_ID3] = this.getSetCoopFlg(this.categoryGoodsList[row][this.COOP_COL_ID3]);
    this.categoryGoodsList[row][this.COOP_COL_ID4] = this.getSetCoopFlg(this.categoryGoodsList[row][this.COOP_COL_ID4]);
    this.categoryGoodsList[row][this.COOP_COL_ID5] = this.getSetCoopFlg(this.categoryGoodsList[row][this.COOP_COL_ID5]);
    this.categoryGoodsList[row][this.COOP_COL_ID6] = this.getSetCoopFlg(this.categoryGoodsList[row][this.COOP_COL_ID6]);
    this.categoryGoodsList[row][this.COOP_COL_ID7] = this.getSetCoopFlg(this.categoryGoodsList[row][this.COOP_COL_ID7]);
    this.categoryGoodsList[row][this.COOP_COL_ID8] = this.getSetCoopFlg(this.categoryGoodsList[row][this.COOP_COL_ID8]);
  }

  /**
   * カテゴリ関連一覧「全生協を解除」処理
   */
  public unsetCoopFlgAll(pcode: string, colId: string): void {
    // 対象行を取得
    const row: number = this.getCategoryGoodsRowNum(pcode);

    // 対象行のチェック
    if (row < 0) { // 未選択の場合
      return;
    }

    // フラグを設定
    this.categoryGoodsList[row][this.COOP_COL_ID1] = this.getUnsetCoopFlg(this.categoryGoodsList[row][this.COOP_COL_ID1]);
    this.categoryGoodsList[row][this.COOP_COL_ID2] = this.getUnsetCoopFlg(this.categoryGoodsList[row][this.COOP_COL_ID2]);
    this.categoryGoodsList[row][this.COOP_COL_ID3] = this.getUnsetCoopFlg(this.categoryGoodsList[row][this.COOP_COL_ID3]);
    this.categoryGoodsList[row][this.COOP_COL_ID4] = this.getUnsetCoopFlg(this.categoryGoodsList[row][this.COOP_COL_ID4]);
    this.categoryGoodsList[row][this.COOP_COL_ID5] = this.getUnsetCoopFlg(this.categoryGoodsList[row][this.COOP_COL_ID5]);
    this.categoryGoodsList[row][this.COOP_COL_ID6] = this.getUnsetCoopFlg(this.categoryGoodsList[row][this.COOP_COL_ID6]);
    this.categoryGoodsList[row][this.COOP_COL_ID7] = this.getUnsetCoopFlg(this.categoryGoodsList[row][this.COOP_COL_ID7]);
    this.categoryGoodsList[row][this.COOP_COL_ID8] = this.getUnsetCoopFlg(this.categoryGoodsList[row][this.COOP_COL_ID8]);
  }

  /**
   * 更新イベント用VO取得
   */
  public getUpdateVo(): KYMW5400commonModel {
    const vo: KYMW5400commonModel = new KYMW5400commonModel();

    vo.categoryDiv = this.categoryDiv;
    vo.orderCode = this.orderCode;

    // ツリーよりカテゴリコードを取得
    const selectedItem: any = this.kymw5400Component.tre_Category.selectedItem;
    vo.categoryCode = selectedItem.CategoryCode;

    // カテゴリ関連情報リストを作成
    const list: Array<any> = [];
    let obj: any = new Object();
    for (let i = Number(0); i < this.categoryGoodsList.length; i++) {
      // 「EC掲載順」の値が変更されたものは「更新区分：2」を設定する。
      const isUpdate = this.categoryGoodsList[i].isEditedECShowSeq;

      // いばらき
      if (this.categoryGoodsList[i][this.COOP_COL_ID1] === '3'
        || this.categoryGoodsList[i][this.COOP_COL_ID1] === '4') {
        obj = new Object();
        obj.updateDiv = this.getUpdateDiv(this.categoryGoodsList[i][this.COOP_COL_ID1]);
        obj.pcode = this.categoryGoodsList[i].PCode;
        obj.coopCode = this.kymw5400Component.kymw00Model.COOP_CODE_IB;
        obj.ecShowSeq = this.categoryGoodsList[i].ECShowSeq;
        list.push(obj);
      }
      // とちぎ
      if (this.categoryGoodsList[i][this.COOP_COL_ID2] === '3'
        || this.categoryGoodsList[i][this.COOP_COL_ID2] === '4') {
        obj = new Object();
        obj.updateDiv = this.getUpdateDiv(this.categoryGoodsList[i][this.COOP_COL_ID2]);
        obj.pcode = this.categoryGoodsList[i].PCode;
        obj.coopCode = this.kymw5400Component.kymw00Model.COOP_CODE_TO;
        obj.ecShowSeq = this.categoryGoodsList[i].ECShowSeq;
        list.push(obj);
      }
      // ぐんま
      if (this.categoryGoodsList[i][this.COOP_COL_ID3] === '3'
        || this.categoryGoodsList[i][this.COOP_COL_ID3] === '4') {
        obj = new Object();
        obj.updateDiv = this.getUpdateDiv(this.categoryGoodsList[i][this.COOP_COL_ID3]);
        obj.pcode = this.categoryGoodsList[i].PCode;
        obj.coopCode = this.kymw5400Component.kymw00Model.COOP_CODE_GU;
        obj.ecShowSeq = this.categoryGoodsList[i].ECShowSeq;
        list.push(obj);
      }
      // ちば
      if (this.categoryGoodsList[i][this.COOP_COL_ID4] === '3'
        || this.categoryGoodsList[i][this.COOP_COL_ID4] === '4') {
        obj = new Object();
        obj.updateDiv = this.getUpdateDiv(this.categoryGoodsList[i][this.COOP_COL_ID4]);
        obj.pcode = this.categoryGoodsList[i].PCode;
        obj.coopCode = this.kymw5400Component.kymw00Model.COOP_CODE_TI;
        obj.ecShowSeq = this.categoryGoodsList[i].ECShowSeq;
        list.push(obj);
      }
      // さいたま
      if (this.categoryGoodsList[i][this.COOP_COL_ID5] === '3'
        || this.categoryGoodsList[i][this.COOP_COL_ID5] === '4') {
        obj = new Object();
        obj.updateDiv = this.getUpdateDiv(this.categoryGoodsList[i][this.COOP_COL_ID5]);
        obj.pcode = this.categoryGoodsList[i].PCode;
        obj.coopCode = this.kymw5400Component.kymw00Model.COOP_CODE_SA;
        obj.ecShowSeq = this.categoryGoodsList[i].ECShowSeq;
        list.push(obj);
      }
      // とうきょう
      if (this.categoryGoodsList[i][this.COOP_COL_ID6] === '3'
        || this.categoryGoodsList[i][this.COOP_COL_ID6] === '4') {
        obj = new Object();
        obj.updateDiv = this.getUpdateDiv(this.categoryGoodsList[i][this.COOP_COL_ID6]);
        obj.pcode = this.categoryGoodsList[i].PCode;
        obj.coopCode = this.kymw5400Component.kymw00Model.COOP_CODE_TK;
        obj.ecShowSeq = this.categoryGoodsList[i].ECShowSeq;
        list.push(obj);
      }
      // ながの
      if (this.categoryGoodsList[i][this.COOP_COL_ID7] === '3'
        || this.categoryGoodsList[i][this.COOP_COL_ID7] === '4') {
        obj = new Object();
        obj.updateDiv = this.getUpdateDiv(this.categoryGoodsList[i][this.COOP_COL_ID7]);
        obj.pcode = this.categoryGoodsList[i].PCode;
        obj.coopCode = this.kymw5400Component.kymw00Model.COOP_CODE_NA;
        obj.ecShowSeq = this.categoryGoodsList[i].ECShowSeq;
        list.push(obj);
      }
      // にいがた
      if (this.categoryGoodsList[i][this.COOP_COL_ID8] === '3'
        || this.categoryGoodsList[i][this.COOP_COL_ID8] === '4') {
        obj = new Object();
        obj.updateDiv = this.getUpdateDiv(this.categoryGoodsList[i][this.COOP_COL_ID8]);
        obj.pcode = this.categoryGoodsList[i].PCode;
        obj.coopCode = this.kymw5400Component.kymw00Model.COOP_CODE_NI;
        obj.ecShowSeq = this.categoryGoodsList[i].ECShowSeq;
        list.push(obj);
      }
      // 掲載順更新時処理
      if (isUpdate) {
        // バックエンドで商品単位で更新するため生協の情報(coopCode)は不要だが、validationに引っかからないようダミーコードを設定
        obj = new Object();
        obj.updateDiv = '2';
        obj.pcode = this.categoryGoodsList[i].PCode;
        obj.coopCode = "999";
        obj.ecShowSeq = this.categoryGoodsList[i].ECShowSeq;
        list.push(obj);
      }
    }

    vo.goodsCategoryInfoList = list;

    // 更新イベント用VOを返却
    return vo;
  }

  private getUpdateDiv(coopFlg: string): string {
    if (coopFlg === '3') {
      return '0';
    } else if (coopFlg === '4') {
      return '1'
    }
    return '2';
  }

  ///////////////////////////////////////////////////////////////////////////////////////////
  // Util Area
  ///////////////////////////////////////////////////////////////////////////////////////////

  /**
   * クリア
   * カテゴリ一覧のクリアを行う
   */
  public clean(): void {
    // カテゴリ一覧データの初期化
    this.categoryInfoList = [];
  }

  /**
   * 引数のオブジェクトをArrayCollectionに変換して返却する。
   * （nullオブジェクト対応版：nullの場合、空のArreyCollectionを返却する）
   */
  public convObjectToArrayCollection(obj: any): Array<any> {
    let retList: Array<any> = [];
    if (obj != null) {
      retList = (obj);
    }
    return retList;
  }

  /**
   * カテゴリ関連一覧で選択中の行に対する行番号を取得する
   */
  private getCategoryGoodsRowNum(pcode: string): number {
    let val = Number(-1);
    for (let i = Number(0); i < this.categoryGoodsList.length; i++) {
      if (pcode === this.categoryGoodsList[i].PCode) {
        val = i;
      }
    }
    return val;
  }

  /**
   * 設定時の生協フラグ取得
   */
  private getSetCoopFlg(oldFlg: string): string {
    let flg = String('');
    switch (oldFlg) {
      // 取扱可能 → 取扱
      case '1':
        flg = '3';
        this.isEdited = true;
        break;
      // 解除 → 設定済
      case '4':
        flg = '2';
        this.isEdited = true;
        break;
      default:
        flg = oldFlg;
        break;
    }
    return flg;
  }

  /**
   * 解除時の生協フラグ取得
   */
  private getUnsetCoopFlg(oldFlg: string): string {
    let flg = String('');
    switch (oldFlg) {
      // 設定済→ 取扱解除
      case '2':
        flg = '4';
        this.isEdited = true;
        break;
      // 設定 → 取扱可能
      case '3':
        flg = '1';
        this.isEdited = true;
        break;
      default:
        flg = oldFlg;
        break;
    }
    return flg;
  }

  /**
   * 商品件数初期化
   */
  public initGoodsCount(): void {
    // カテゴリ商品設定一覧の生協・いばらき 商品件数
    this.coopIGoodsCount = 0;
    // カテゴリ商品設定一覧の生協・とちぎ 商品件数
    this.coopToGoodsCount = 0;
    // カテゴリ商品設定一覧の生協・ぐんま 商品件数
    this.coopGuGoodsCount = 0;
    // カテゴリ商品設定一覧の生協・ちば 商品件数
    this.coopChiGoodsCount = 0;
    // カテゴリ商品設定一覧の生協・さいたま 商品件数
    this.coopSaGoodsCount = 0;
    // カテゴリ商品設定一覧の生協・とうきょう 商品件数
    this.coopTouGoodsCount = 0;
    // カテゴリ商品設定一覧の生協・ながの 商品件数
    this.coopNaGoodsCount = 0;
    // カテゴリ商品設定一覧の生協・にいがた 商品件数
    this.coopNiGoodsCount = 0;
    // カテゴリ商品設定一覧の全生協 商品件数
    this.coopAllGoodsCount = 0;
  }
}
